import React, { KeyboardEvent } from 'react';
import { upperFirst } from 'lodash';
import { TextField as MTextField, OutlinedTextFieldProps } from '@mui/material';

// @ts-ignore
interface Props extends OutlinedTextFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  value: string | number;
  error?: any;
  touched?: boolean;
  helperText?: string;
  fullWidth?: boolean;
  className?: string;
  variant?: any;
  size?: 'small' | 'medium';
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEnterPress?: () => void;
}

const TextField: React.FC<Props> = ({
  onEnterPress,
  error,
  className,
  label,
  touched,
  ...rest
}) => {
  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key !== 'Enter' || !onEnterPress) return;

    e.preventDefault();
    onEnterPress();
  };

  const { InputProps, inputProps, ...otherProps } = rest;
  
  return (
    <MTextField
      {...otherProps}
      classes={{ root: className }}
      aria-label={label}
      variant="outlined"
      label={upperFirst(label)}
      error={!!error && touched}
      helperText={
        error && touched ? upperFirst(String(error)) : rest.helperText
      }
      onKeyPress={handleKeyPress}
      InputLabelProps={{
        htmlFor: rest.name,
        id: `${label}-label`,
      }}
      inputProps={{ 'aria-label': `${label}-label`, ...inputProps }}
      InputProps={InputProps}
    />
  );
};

export default TextField;
